module.exports = __webpack_public_path__ + "static/hero-logo-row-3-dffe75edd2d7736db773cc1998e7430d.png";